/* eslint-disable angular/document-service */
export const loadTheme = (theme, onloadCallback) => {
  const url = `${theme}.bundle.js`;
  const script = document.createElement('script');
  const scripts = document.getElementsByTagName('script');
  const lastScript = scripts[scripts.length - 1];
  script.src = url;
  script.onload = onloadCallback;

  // Insert custom script into head
  lastScript.parentNode.insertBefore(script, lastScript.nextSibling);

  // Add custom class name to body
  document.getElementsByTagName('body')[0].classList.add(theme);
};

/* eslint-disable angular/document-service */
export const loadTranslations = (theme, $translatePartialLoaderProvider) => {
  // add custom translation
  const customI18NUrl = `custom/${theme}`;
  $translatePartialLoaderProvider.addPart(customI18NUrl);
};
